import React from 'react';
import { Link } from 'react-router';

import styles from './index.css';

const renderListItem = (list, closeMenu) =>
	list.map(item => {
		let button = null;
		switch (item.type) {
			case 'external':
				button = (
					<a
						key={item.id}
						className={styles.item}
						href={item.url}
						target="_blank"
						onClick={closeMenu}
					>
						{item.name}
					</a>
				);
				break;
			case 'internal':
				button = (
					<Link key={item.id} className={styles.item} to={item.url} onClick={closeMenu}>
						{item.name}
					</Link>
				);
				break;
			case 'action':
				button = (
					<button
						key={item.id}
						className={styles.item}
						onClick={() => {
							closeMenu();
							if (item.onClick) {
								item.onClick();
							}
						}}
					>
						{item.name}
					</button>
				);
				break;
			default:
				button = null;
				break;
		}
		return button;
	});

const MenuBlock = ({ title, list, titleLink, closeMenu }) => (
	<div className={styles.menuBlock}>
		<div className={styles.title}>
			{titleLink ? (
				<a href={titleLink} target="_blank">
					{title}
				</a>
			) : (
				title
			)}
		</div>
		<div className={styles.list}>{renderListItem(list, closeMenu)}</div>
	</div>
);

export default MenuBlock;



// WEBPACK FOOTER //
// ./src/components/atoms/MenuBlock/index.js